/* ============================================================
   MARCHE À L'OMBRE — theme.js
   Aucune dépendance externe. Vanilla JS, ES6.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    var f = (window.MAO && window.MAO.moneyFormat) || '{{amount_with_comma_separator}} €';
    var val = (cents / 100).toFixed(2).replace('.', ',');
    return f.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, val);
  };

  /* --- 1. Menu mobile ------------------------------------- */
  var burger = document.querySelector('[data-burger]');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.querySelectorAll('.mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('nav-open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('nav-open')) burger.click();
    });
  }

  /* --- 2. Header transparent -> solide -------------------- */
  var header = document.querySelector('[data-header-overlay]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- 3. Révélation au scroll ---------------------------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --- 4. Accordéons -------------------------------------- */
  document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.accordion__item');
      var panel = item.querySelector('.accordion__panel');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* --- 5. Quantité ---------------------------------------- */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'up' ? 1 : -1;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* --- 6. Sélecteur de variantes -------------------------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = document.getElementById(form.dataset.variantsId);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var comparePriceEl = form.querySelector('[data-compare-price]');
    var submit = form.querySelector('[data-add]');
    var skuEl = form.querySelector('[data-sku]');

    var currentOptions = function () {
      return Array.from(form.querySelectorAll('input[type="radio"]:checked')).map(function (i) { return i.value; });
    };

    var findVariant = function (opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    };

    var render = function () {
      var opts = currentOptions();
      var v = findVariant(opts);

      // état visuel des swatches
      form.querySelectorAll('.swatch').forEach(function (s) {
        var input = s.querySelector('input');
        s.classList.toggle('is-selected', input.checked);
      });

      // options indisponibles (sur le dernier groupe d'options)
      var groups = form.querySelectorAll('[data-option-index]');
      if (groups.length) {
        var last = groups[groups.length - 1];
        var idx = parseInt(last.dataset.optionIndex, 10);
        last.querySelectorAll('.swatch').forEach(function (s) {
          var test = opts.slice();
          test[idx] = s.querySelector('input').value;
          var m = findVariant(test);
          s.classList.toggle('is-unavailable', !m || !m.available);
        });
      }

      if (!v) {
        submit.disabled = true;
        submit.textContent = window.MAO.t.unavailable;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparePriceEl.textContent = money(v.compare_at_price);
          comparePriceEl.hidden = false;
        } else { comparePriceEl.hidden = true; }
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      submit.disabled = !v.available;
      submit.textContent = v.available ? window.MAO.t.addToCart : window.MAO.t.soldOut;

      // URL propre pour le partage / SEO
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    };

    form.querySelectorAll('input[type="radio"]').forEach(function (i) {
      i.addEventListener('change', render);
    });
    render();

    /* --- 7. Ajout au panier en AJAX ----------------------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submit.disabled = true;
      submit.textContent = window.MAO.t.adding;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(idInput.value, 10), quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10) }]
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || window.MAO.t.error);
          submit.textContent = window.MAO.t.added;
          refreshCartCount();
          setTimeout(function () { submit.textContent = window.MAO.t.addToCart; submit.disabled = false; }, 1600);
        })
        .catch(function (err) {
          submit.textContent = window.MAO.t.addToCart;
          submit.disabled = false;
          var box = form.querySelector('[data-form-error]');
          if (box) { box.textContent = err.message; box.hidden = false; }
        });
    });
  });

  /* --- 8. Compteur panier --------------------------------- */
  function refreshCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      })
      .catch(function () {});
  }
  window.MAORefreshCart = refreshCartCount;

  /* --- 9. Mise à jour des lignes du panier ---------------- */
  document.querySelectorAll('[data-cart-item]').forEach(function (row) {
    var key = row.dataset.cartItem;
    var input = row.querySelector('input[name="updates[]"]');
    var update = function (qty) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    };
    row.querySelectorAll('[data-qty] button').forEach(function (b) {
      b.addEventListener('click', function () {
        setTimeout(function () { update(parseInt(input.value, 10)); }, 60);
      });
    });
    var remove = row.querySelector('[data-remove]');
    if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); update(0); });
  });

  /* --- 10. Bandeau cookies (RGPD) ------------------------- */
  var banner = document.querySelector('[data-cookies]');
  if (banner) {
    var KEY = 'mao_consent_v1';
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    if (!stored) banner.classList.add('is-visible');

    var setConsent = function (value) {
      try { localStorage.setItem(KEY, value); } catch (e) {}
      banner.classList.remove('is-visible');
      // API de consentement Shopify (Customer Privacy API)
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(value === 'accepted', function () {});
      }
    };
    banner.querySelector('[data-accept]').addEventListener('click', function () { setConsent('accepted'); });
    banner.querySelector('[data-decline]').addEventListener('click', function () { setConsent('declined'); });
  }

  /* --- 11. Galerie produit : lazy + ratio ----------------- */
  document.querySelectorAll('.product__gallery img').forEach(function (img, i) {
    if (i > 0) img.loading = 'lazy';
  });
})();
